export const stripHtml = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

export function extractTargetValues(input: string): string[] {
  const result: string[] = [];
  const regex = /\{\{([A-Z_]+)\}\}/g;
  let match;

  while ((match = regex.exec(input)) !== null) {
    result.push(match[1]);
  }

  return result;
}
